module.exports = __webpack_public_path__ + "img/elo.54902a8a.svg";